import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import { getMathValue } from './math'
import type { joinValueSchema } from './schema'
import { getSimpleValue } from './simpleValue'
import { getSliceValue } from './slice'

export const getJoinValue = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof joinValueSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): string => {
  let joinValue = ''
  for (const value of schema.values) {
    if (typeof value === 'string') {
      joinValue += value
      continue
    }
    switch (value.type) {
      case 'math': {
        // math value
        joinValue += getMathValue({
          schema: value,
          transaction,
          relatedAddresses,
        }).toString()
        break
      }
      case 'slice': {
        // slice value
        joinValue += getSliceValue({
          schema: value,
          transaction,
          relatedAddresses,
        })
        break
      }
      case 'function':
      case 'value':
      case 'chain-id':
      case 'tx-hash':
      case 'from':
      case 'to':
      case 'log':
      case 'erc20':
      case 'erc721':
      case 'erc1155': {
        // simple value
        joinValue += getSimpleValue({
          schema: value,
          transaction,
          relatedAddresses,
        })
        break
      }
      default: {
        throw new Error(`Unknown value type: ${value satisfies never}`)
      }
    }
  }
  return joinValue
}
